import { render } from "./routeDetail.vue?vue&type=template&id=7471b680&scoped=true"
import script from "./routeDetail.vue?vue&type=script&lang=js"
export * from "./routeDetail.vue?vue&type=script&lang=js"

import "./routeDetail.vue?vue&type=style&index=0&id=7471b680&scoped=true&lang=css"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7471b680"]])

export default __exports__